var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none",
    viewBox: "0 0 65 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F0F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27AAE1",
    fillRule: "evenodd",
    d: "M32.833 26.166a.833.833 0 0 0-1.666 0v5h-5a.833.833 0 0 0 0 1.667h5v5a.833.833 0 0 0 1.666 0v-5h5a.833.833 0 1 0 0-1.667h-5v-5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLogo);
export default __webpack_public_path__ + "static/media/add_logo.762bb661250b9b50818eac29bce1503d.svg";
export { ForwardRef as ReactComponent };